import { rejectSubmission } from '../../../../services/popupApi';
import { rejectionReasons } from './config';

export const api = {
  submit: async (values, context) => {
    // The popup's Select field normalizes every option value to a string
    // (see fieldRegistry.normalizeSelectOptions), so values.rejectReason is
    // "1"/"2"/"3" even though rejectionReasons.id is numeric — compare as
    // strings or the lookup always misses and the reason silently blanks out.
    const reason = rejectionReasons.find((r) => String(r.id) === String(values.rejectReason));
    await rejectSubmission({
      submissionId: context.selectedIds[0],
      rejectReasonId: values.rejectReason,
      rejectReason: reason?.name ?? '',
      rejectReasonComments: values.rejectReasonComments,
    });
  },
};
